export var MixpanelEvents;
(function (MixpanelEvents) {
    MixpanelEvents["BASE_AUDIENCES_VIEWED"] = "base-audiences_viewed";
})(MixpanelEvents || (MixpanelEvents = {}));
